import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from '../components/Navbar';

export default function Privacy() {
    const navigate = useNavigate();
    return (
        <div className="app-wrap">
            <Helmet>
                <title>Privacy Policy | OnlineICO</title>
                <meta name="description" content="Read the Privacy Policy of OnlineICO. Learn how we collect, use and protect your personal data on our crypto presales directory." />
                <link rel="canonical" href="https://onlineico.com/privacy" />
            </Helmet>
            <Navbar />
            <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 1.5rem 80px' }}>
                <button onClick={() => navigate(-1)} style={{ background: 'none', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '30px', color: '#94a3b8', fontSize: '0.85rem', cursor: 'pointer', padding: '8px 16px', marginBottom: '32px' }}>← Back</button>

                <h1 style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '2rem', color: '#F1F5F9', marginBottom: '8px' }}>Privacy Policy</h1>
                <p style={{ color: '#64748b', fontSize: '0.85rem', marginBottom: '40px' }}>Last updated: April 2026</p>

                {[
                    {
                        title: '1. Introduction',
                        content: `OnlineICO ("we", "us", "our") is committed to protecting your personal data. This Privacy Policy explains how we collect, use, and protect information when you use our Platform at onlineico.com.`
                    },
                    {
                        title: '2. Data We Collect',
                        content: `We collect the following information: (a) Account data: username, email address, and password hash when you register. (b) Project data: information you submit about your crypto project. (c) Wallet addresses: optionally provided for quest reward distribution. (d) Usage data: IP addresses, browser type, pages visited, and timestamps for security and analytics purposes. (e) Payment data: transaction hashes submitted for promotional services (we do not store private keys or full wallet credentials).`
                    },
                    {
                        title: '3. How We Use Your Data',
                        content: `Your data is used to: provide and improve our services, manage your account and project listings, send transactional emails (account verification, password reset, order confirmation), distribute quest rewards to your wallet address, detect and prevent fraud and abuse, and comply with legal obligations.`
                    },
                    {
                        title: '4. Data Sharing',
                        content: `We do not sell your personal data to third parties. We may share data with trusted service providers (email delivery, hosting) under strict confidentiality agreements. We may disclose data if required by law or to protect the rights and safety of our users.`
                    },
                    {
                        title: '5. Data Retention',
                        content: `We retain your account data for as long as your account is active. If you request account deletion, your personal data will be permanently removed within 30 days, except where retention is required by law.`
                    },
                    {
                        title: '6. Your Rights',
                        content: `You have the right to access, correct, or delete your personal data. You may also request data portability or restrict processing. To exercise these rights, contact us at contact@onlineico.com. We will respond within 30 days.`
                    },
                    {
                        title: '7. Security',
                        content: `We implement industry-standard security measures including password hashing (bcrypt), JWT-based authentication, and HTTPS encryption. However, no method of transmission over the internet is 100% secure. We encourage users to use strong, unique passwords.`
                    },
                    {
                        title: '8. Third-Party Links',
                        content: `Our Platform may contain links to third-party websites (project websites, social media). We are not responsible for the privacy practices of these external sites. We encourage you to review their privacy policies before providing any personal information.`
                    },
                    {
                        title: '9. Changes to This Policy',
                        content: `We may update this Privacy Policy from time to time. We will notify registered users of significant changes via email. Continued use of the Platform after changes constitutes acceptance of the updated policy.`
                    },
                    {
                        title: '10. Contact',
                        content: `For privacy-related inquiries, please contact us at contact@onlineico.com.`
                    },
                ].map((section, i) => (
                    <div key={i} style={{ marginBottom: '32px' }}>
                        <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '1.05rem', color: '#F1F5F9', marginBottom: '10px' }}>{section.title}</h2>
                        <p style={{ color: '#94a3b8', fontSize: '0.9rem', lineHeight: '1.8' }}>{section.content}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
